import axios from 'axios';
import handleError from 'helpers/HandleError';
import { getStorageToken, getToken } from './Cookies';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
   failedQueue.forEach((prom) => {
      if (error) {
         prom.reject(error);
      } else {
         prom.resolve(token);
      }
   });

   failedQueue = [];
};

const getInstance = () => {
   const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      timeout: process.env.REACT_APP_TIMEOUT || 10000,
      headers: {
         'Content-Type': 'application/json',
      },
   });
   instance.interceptors.response.use(
      async (config) => {
         return config;
      },
      async (error) => {
         const newConfig = error.config;
         if (error?.response?.status === 401 && !newConfig._retry) {
            if (isRefreshing) {
               return new Promise(function (resolve, reject) {
                  failedQueue.push({ resolve, reject });
               })
                  .then((token) => {
                     newConfig.headers['X-AUTH-TOKEN'] = token;
                     return axios(newConfig);
                  })
                  .catch((err) => {
                     return Promise.reject(err);
                  });
            }
            newConfig._retry = true;
            isRefreshing = true;
            try {
               const token = await getStorageToken();
               if (token) {
                  processQueue(null, token);
                  newConfig.headers['X-AUTH-TOKEN'] = token;
                  return axios(newConfig);
               }
            } catch (err) {
               processQueue(err, null);
               Promise.reject(err);
            } finally {
               isRefreshing = false;
            }
         }
         return Promise.reject(error);
      },
   );
   instance.interceptors.request.use(
      async (config) => {
         if (
            config.method === 'get' ||
            config.method === 'delete' ||
            config.data === undefined
         ) {
            config.data = true;
         }
         const newConfig = config;
         const token = await getToken();
         if (token) {
            newConfig.headers['X-AUTH-TOKEN'] = token;
         }
         return newConfig;
      },
      (error) => Promise.reject(error),
   );
   return instance;
};
const httpRequest = (method, path, data, headers = {}, timeout = true) => {
   return new Promise((resolve, reject) => {
      getInstance(timeout)
         [method](path, data, headers)
         .then((response) => resolve(response))
         .catch((error) => reject(handleError(error)));
   });
};
export default {
   get(path, data, headers) {
      return httpRequest('get', path, data, headers);
   },
   post(path, data, headers) {
      return httpRequest('post', path, data, headers);
   },
   postNoTimeout(path, data, headers) {
      return httpRequest('post', path, data, headers);
   },
   put(path, data, headers) {
      return httpRequest('put', path, data, headers);
   },
   delete(path, data, headers) {
      return httpRequest('delete', path, data, headers);
   },
   patch(path, data, headers) {
      return httpRequest('patch', path, data, headers);
   },
};
